import 'css-chunksrc/client/scenes/workloads/wbs/commentsCount/styles.scss';export default {
  "commentsCount": "_commentsCount_dsqsw_1",
  "count": "_count_dsqsw_8",
  "icon": "_icon_dsqsw_14"
};